export default "__VITE_ASSET__fa08f470__"